import { cn } from '@/common/utils/cn'
import { Control, Path } from 'react-hook-form'

interface RadioCardsProps<T extends object> {
  control?: Control<T>
  name?: Path<T>
  options:
    | {
        value: string
        title: string | JSX.Element
        description?: string | JSX.Element
        disabled?: boolean
      }[]
    | undefined
  value?: string | undefined
  onValueChange?: (value: string) => void
  containerClassName?: string
  cardClassName?: string
  selectedCardClassName?: string
  radioIconClassName?: string
}

const RadioCards = <T extends object>({
  options,
  value,
  onValueChange,
  containerClassName,
  cardClassName,
  selectedCardClassName,
  radioIconClassName,
}: RadioCardsProps<T>) => {
  return (
    <div className={cn('flex flex-col gap-2', containerClassName)}>
      {options?.map((option) => {
        const isChecked = value === option.value

        return (
          <button
            key={option.value}
            className={cn(
              'bg-white-100 hover:opacity-85 transition-colors cursor-pointer rounded-md p-4 flex flex-col items-start gap-2 disabled:opacity-75 disabled:text-white-400 disabled:cursor-default disabled:pointer-events-none',
              cardClassName,
              isChecked && cn('bg-success-op', selectedCardClassName),
            )}
            onClick={() => onValueChange?.(option.value)}
            disabled={option.disabled}
          >
            <div className="flex items-center justify-between w-full gap-2 flex-wrap">
              <div className="flex items-center gap-2">
                <div
                  className={cn(
                    'min-w-3 min-h-3 max-w-3 max-h-3 rounded-full border border-white-400 flex items-center justify-center',
                    radioIconClassName,
                  )}
                >
                  {isChecked && <div className="bg-white-800 size-1.5 rounded-full" />}
                </div>

                {typeof option.title === 'string' ? (
                  <p className="font-bold text-sm text-left">{option.title}</p>
                ) : (
                  option.title
                )}
              </div>
            </div>

            {typeof option.description === 'string' ? (
              <div>
                <p className="text-xs text-white-400 whitespace-pre-wrap text-left">{option.description}</p>
              </div>
            ) : (
              option.description
            )}
          </button>
        )
      })}
    </div>
  )
}

export default RadioCards
